module.exports = __webpack_public_path__ + "static/media/turkey-flag-square-medium.f2bbcd04.png";